import React from 'react';

import {hexToRgbA, hexColorDelta, rgbToHex} from '../../components/UniversalMethods';

import { GetCloseColorPallettes, UpdateFavicon } from '../../components/UniversalMethods';

import PalletteThumbnail from '../../components/PalletteThumbnail/PalletteThumbnail';
import TextArea from '../../components/TextArea/TextArea';

import './Converter.css';
import { CloseButton } from '../../components/Button/Button';

class Converter extends React.Component {

  constructor(props){
    super(props);

    this.state = {
        loaded: false,
        hexValueText: '',
        hexValue: '',
        textHexValue: '',
        rgb: {
          r: '',
          g: '',
          b: ''
        },
        alertText: '',
        parellet: []
    };
  }

  componentDidMount = () => {
    if(typeof this.props.match.params.id === 'undefined'){
      // Hex is empty
      this.props.history.push("../hex/440088");
    }else{
      // Hex is available
      this.updateHex(this.props.match.params.id, 'mount');
    }
    
  }
  componentDidUpdate = (prevProps) => {
    if(prevProps !== this.props) this.updateHex(this.props.match.params.id, 'update');
  }

  updateHex = (hexValue, mode) => {
    
    window.scrollTo(0, 0);

    clearTimeout(this.timer);

    const rgb = hexToRgbA(hexValue);
    
    if(mode === 'mount' || mode === 'update'){

        // update the color
        this.props.updateColor(hexValue);
        // document title
        document.title = "HEX i HUE - Color pallettes: #" + hexValue;
        UpdateFavicon(hexValue);

        this.setState({
            loaded: true,
            hexValueText: hexValue,
            hexValue: hexValue,
            textHexValue: hexColorDelta(hexValue, 'ffffff') > 0.7? '2a2a2a' : 'fff',
            rgb: rgb
        });
    }else{
        this.setState({
            hexValueText: hexValue,
        });

        this.timer = setTimeout(() => {
            this.props.history.push("../hex/" + hexValue);
            this.setState({
              hexValueText: hexValue,
              rgb: rgb
            });
            clearTimeout(this.timer);
        }, 500);
    }

  }


  colorCallback = (color) => {
    this.props.history.push("../hex/" + color);
    // if(this.transitionChecker) return;
    // this.transitionChecker = true;

    // this.setState({
    //     transition: color
    // })
    
    // this.timer = setTimeout(() => {
    //     this.props.history.push("../hex/" + color);
    //     clearTimeout(this.timer);
    // }, 400);
    
  }

  updateRgb = (key, value) => {
  
    let newRgb = this.state.rgb;

    // the value is not number NOR wrong format
    if(isNaN(parseInt(value))){
      newRgb[key] = value;
      this.setState({
        rgb: newRgb,
        alertText: 'Please check if RGB values are in number, 0-255'
      });
    }else{
      newRgb[key] = parseInt(value);
      // update hex
      const hexValue = rgbToHex(newRgb);
      // alert
      let alertText = '';
      for (const [key, v] of Object.entries(newRgb)) {
        if(v>255 || v<0) alertText ='Please check if RGB numbers are in 0-255';
      };
      this.setState({
        hexValueText: hexValue,
        hexValue: hexValue,
        rgb: newRgb,
        alertText: alertText
      });
    }

  }

  goToEdit = () => {

  }

  render() {
    console.log(this.state.alertText);
      return <div className='converter' style={{backgroundColor: '#' + this.state.hexValue}}>
        <CloseButton 
          style={{position: 'absolute', top: '1rem', right: '1rem'}}
          className={`${this.state.textHexValue === 'fff' ? 'icon-light' : 'icon-dark'}`}
          callback={() => this.props.history.push("../")}
        />
        <div className='converter-container'>
          <TextArea 
              className = {`key ${this.state.loaded ? 'visible' : 'hidden' }`}
              type = 'hex'
              value= {this.state.hexValueText}
              placeHolder = 'Input hex value'
              callback = {this.updateHex}
              textAreaStyle={{color: '#' + this.state.textHexValue}}
          />
          <div className='rgb-container'>
            <div className='values'>
              <TextArea 
                  className = {`rgb r ${this.state.loaded ? 'visible' : 'hidden' }`}
                  type = 'r'
                  value= {this.state.rgb.r}
                  placeHolder = 'Input hex value'
                  callback = {this.updateRgb}
                  textAreaStyle={{color: '#' + this.state.textHexValue, borderColor: '#' + this.state.textHexValue}}
              />
              <TextArea 
                  className = {`rgb g ${this.state.loaded ? 'visible' : 'hidden' }`}
                  type = 'g'
                  value= {this.state.rgb.g}
                  placeHolder = 'Input hex value'
                  callback = {this.updateRgb}
                  textAreaStyle={{color: '#' + this.state.textHexValue, borderColor: '#' + this.state.textHexValue}}
              />
              <TextArea 
                  className = {`rgb b ${this.state.loaded ? 'visible' : 'hidden' }`}
                  type = 'b'
                  value= {this.state.rgb.b}
                  placeHolder = 'Input hex value'
                  callback = {this.updateRgb}
                  textAreaStyle={{color: '#' + this.state.textHexValue, borderColor: '#' + this.state.textHexValue}}
              />
            </div>
          </div>
          {this.state.alertText !== '' ? <div className='alert-text'>{this.state.alertText}</div> : ''}

          <div className='pallette-thumbnail-container'>
              {GetCloseColorPallettes(this.state.hexValue).map(pallettes => <PalletteThumbnail colors={pallettes.colors} colorCallback = {this.colorCallback} textColor={this.state.textHexValue} highlightColor={this.state.hexValue}/>)}
          </div>
        </div>
      </div>
  }
}

export default Converter;